(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["accordion"] && !Shopify.designMode) return;
  try {
    
  class ThemeAccordion {
    constructor(root) {
      this.root = root;
      this.allowMultiple = root.dataset.allowMultiple === 'true';
      this.items = [...root.querySelectorAll('[data-accordion-item]')];
      this.bindEvents();
    }

    bindEvents() {
      this.items.forEach((item) => {
        item.querySelector('[data-accordion-trigger]')
          ?.addEventListener('click', () => this.toggle(item));
      });
    }

    toggle(item) {
      const isOpen = item.classList.contains('is-open');
      if (!this.allowMultiple && !isOpen) {
        this.items.forEach((other) => { if (other !== item) this.close(other); });
      }
      isOpen ? this.close(item) : this.open(item);
    }

    open(item) {
      item.classList.add('is-open');
      item.querySelector('[data-accordion-trigger]')?.setAttribute('aria-expanded', 'true');
      item.querySelector('[data-accordion-panel]')?.removeAttribute('hidden');
    }

    close(item) {
      item.classList.remove('is-open');
      item.querySelector('[data-accordion-trigger]')?.setAttribute('aria-expanded', 'false');
      item.querySelector('[data-accordion-panel]')?.setAttribute('hidden', '');
    }
  }

  document.querySelectorAll('[data-accordion]').forEach((el) => new ThemeAccordion(el));
  document.addEventListener('shopify:section:load', (e) => {
    e.target.querySelectorAll('[data-accordion]').forEach((el) => new ThemeAccordion(el));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
